export default __webpack_public_path__ + "static/yrsa-v7-latin-regular-8fcfcbf91b66faf6acc02afafb612a1d.woff2";